import { util } from 'echarts/core';
import { type ThemeParser } from '../../../core/theme';
import { ainvestWaterMark } from '../../../assets/dvWaterMarkImgs.js';
import { Z_LIST } from '../../mobile/static/z';

function logoWaterMarkParse(option: Parameters<ThemeParser>[0], themeMode: 'light' | 'dark') {
  const gridHeight = 200;
  const imageHeight = 20;
  const imageMarginBottom = 2;
  option.dvWaterMark = util.merge(
    {
      id: '$DV_WATER_MARK',
      show: true,
      type: 'image',
      left: 16,
      top: gridHeight - imageHeight - imageMarginBottom,
      style: {
        width: 96,
        height: imageHeight,
        image: ainvestWaterMark[themeMode]
      },
      z: Z_LIST.waterMark,
      silent: true
    },
    option.dvWaterMark || {},
    true
  );
}

export function graphicParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  logoWaterMarkParse(option, themeMode);
}
